import React, { useState, useContext } from 'react';
import axios from 'axios';
import { Context } from '../../../src/AppContext';
import { useMediaQuery } from 'react-responsive';
import { format } from 'date-fns';
import { generateUuid } from '../../utils/uuidGenerator';
import './TopBusesRoutes.css';

type TopBusRoutesProps = {
  setcollapsableFlag: React.Dispatch<React.SetStateAction<boolean>>;
  onBusClicked: (
    fromCity: string,
    toCity: string,
    fromCode: string,
    toCode: string
  ) => void;
  noOfListings?: number;
  type: string;
  data;
  name: string;
  localOperator: boolean | null | undefined;
};
const TopBusesRoutes = ({
  name,
  type,
  data,
  noOfListings = 10,
  setcollapsableFlag,
  onBusClicked,
  localOperator = false
}: TopBusRoutesProps) => {
  const { trackTemplateEvent, selectedDay, omniUrlArgs } = useContext(Context);
  const [showFullBuses, setShowFullBuses] = useState(false);

  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });

  const busClick = async (fromCity, toCity, fromCode, toCode) => {
    trackTemplateEvent(
      type === 'Operator'
        ? 'Bus_SEO_Operator_ViewBuses_Click'
        : `Bus_SEO_ViewBuses_Click`
    );
    onBusClicked(fromCity, toCity, fromCode, toCode);
    setcollapsableFlag(false);
    const travelDate = format(selectedDay, 'dd-MM-yyyy');
    const UrlPrefix = isMobileDevice
      ? `https://www.makemytrip.com/mbus/rnw/busListingPage?from=${fromCity}&from_code=${fromCode}&to=${toCity}&to_code=${toCode}&departure=${travelDate}&sort=Rating&`
      : `https://www.makemytrip.com/bus/search/${fromCity}/${toCity}/${travelDate}?from_city=${fromCode}&to_city=${toCode}&`;

    let urlSuffix = `${omniUrlArgs}`;

    if (name !== fromCity && name !== toCity) {
      const filterOption = {
        tag: 'Operator',
        value: name
      };

      const requestBody = {
        type: 'UserSessionSelectionRequest',
        seo: {
          pageName: 'Operator',
          filters: [filterOption]
        }
      };

      const sessionId = generateUuid();
      const headers = {
        sessionId
      };

      const endPoint = 'https://bus.makemytrip.com/bus/postFilterContext';
      try {
        const response = await axios.post(endPoint, requestBody, { headers });
      } catch (error) {
        // Handle the error
        console.error(error);
      }

      urlSuffix = `${omniUrlArgs}&sessionId=${sessionId}`;
    }

    const Url = UrlPrefix + urlSuffix;

    if (isMobileDevice) {
      return (window.location = Object(Url));
    } else {
      const newTab = window.open(Url, '_blank');
      return newTab?.focus();
    }
  };

  return (
    <>
      <div
        style={{ display: 'none' }} // disabled in SSR HTML
        className="mobileShow d-relative appendBottom20"
      >
        <div className="cabTypeWrap">
          <div className="cabTypeDetails">
            <div className="cabTypeHead">
              <span className="cabTypeCol">Routes</span>
              <span className="cabTypeCol">
                {type === 'Operator'
                  ? `Popular Bus Types`
                  : `Popular Operators`}
              </span>
              <span className="cabTypeCol">Price</span>
              <span className="cabTypeCol viewDtl"> &nbsp;</span>
            </div>
            {data
              .filter((_, index) => showFullBuses || index < noOfListings)
              .map((item, index) => (
                <div
                  key={index}
                  className={index === 0 ? 'busTypeData noBdr' : 'busTypeData'}
                >
                  <div
                    onClick={() =>
                      busClick(
                        item.from_city_name,
                        item.to_city_name,
                        item.from_city_id,
                        item.to_city_id
                      )
                    }
                  >
                    <div className="wrapper row">
                      <div className="first col">
                        {item.seoUrl ? (
                          <p>
                            <a
                              onClick={e => e.preventDefault()}
                              href={item.seoUrl}
                              className={`cabTypeRoute`}
                            >
                              {`${item.from_city_name} to  ${item.to_city_name} bus`}
                            </a>
                          </p>
                        ) : (
                          <p className={`cabTypeRoute`}>
                            {`${item.from_city_name} to  ${item.to_city_name} bus`}
                          </p>
                        )}
                        <p className="cabTimeDis">
                          {(() => {
                            if (type === 'Operator') {
                              return item.duration ? item.duration : null;
                            } else {
                              let durationAndDistanceString = '';
                              if (item.distance)
                                durationAndDistanceString = `${item.distance} kms `;
                              if (item.duration)
                                durationAndDistanceString = durationAndDistanceString.concat(
                                  item.distance ? `| ` : ``,
                                  `${item.duration}`
                                );
                              return durationAndDistanceString;
                            }
                          })()}
                        </p>
                        {item.duration ||
                        (type.endsWith('City') && item.distance) ? null : (
                          <div className="topOperator">
                            <p>
                              {(() => {
                                //for operator template
                                if (type === 'Operator') {
                                  return item.bus_types ? (
                                    <span>{item.bus_types.join(', ')}</span>
                                  ) : (
                                    <span></span>
                                  );
                                } else {
                                  //for city template
                                  return item.popular_operators
                                    ? item.popular_operators.map(
                                        (operator, idx) => {
                                          return operator.seoUrl ? (
                                            <>
                                              <a
                                                onClick={e =>
                                                  e.preventDefault()
                                                }
                                                key={idx}
                                                className={`topOperatorFont`}
                                                href={operator.seoUrl}
                                              >
                                                {operator.operatorName}
                                              </a>
                                              {idx <
                                              item.popular_operators.length -
                                                1 ? (
                                                <span>, </span>
                                              ) : (
                                                ''
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              <span
                                                key={idx}
                                                className={`topOperatorFont`}
                                              >
                                                {operator.operatorName}
                                              </span>
                                              {idx <
                                              item.popular_operators.length -
                                                1 ? (
                                                <span>, </span>
                                              ) : (
                                                ''
                                              )}
                                            </>
                                          );
                                        }
                                      )
                                    : null;
                                }
                              })()}
                            </p>
                          </div>
                        )}
                      </div>

                      <div className="second col">
                        <p className="cabTypePrice">₹{item.min_price}</p>
                        <p className="cabTypeOnwards">onwards</p>
                      </div>
                    </div>
                    <div className="wrapper row">
                      {item.duration ||
                      (type.endsWith('City') && item.distance) ? (
                        <div className="topOperator">
                          <p>
                            {(() => {
                              //for operator template
                              if (
                                localOperator &&
                                item.firstDepartingBus &&
                                item.lastDepartingBus
                              ) {
                                return (
                                  <span>
                                    <span>{`First Bus : ${item.firstDepartingBus}, Last Bus : ${item.lastDepartingBus}`}</span>
                                  </span>
                                );
                              } else if (type === 'Operator') {
                                return item.bus_types ? (
                                  <span>{item.bus_types.join(', ')}</span>
                                ) : (
                                  <span></span>
                                );
                              } else {
                                //for city template
                                return item.popular_operators
                                  ? item.popular_operators.map(
                                      (operator, idx) => {
                                        return operator.seoUrl ? (
                                          <>
                                            <a
                                              onClick={e => e.preventDefault()}
                                              key={idx}
                                              className={`topOperatorFont`}
                                              href={operator.seoUrl}
                                            >
                                              {operator.operatorName}
                                            </a>
                                            {idx <
                                            item.popular_operators.length -
                                              1 ? (
                                              <span>, </span>
                                            ) : (
                                              ''
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            <span
                                              key={idx}
                                              className={`topOperatorFont`}
                                            >
                                              {operator.operatorName}
                                            </span>
                                            {idx <
                                            item.popular_operators.length -
                                              1 ? (
                                              <span>, </span>
                                            ) : (
                                              ''
                                            )}
                                          </>
                                        );
                                      }
                                    )
                                  : null;
                              }
                            })()}
                          </p>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className="showMoreBuses">
          {data.length > noOfListings && (
            <button
              className="showMoreBusesButton"
              onClick={() => setShowFullBuses(!showFullBuses)}
            >
              {showFullBuses ? 'VIEW LESS' : 'VIEW MORE'}
            </button>
          )}
        </div>
      </div>
      <div className="desktopShow d-relative">
        <div className="cabTypeWrap">
          <table className="cabTypeDetails">
            <thead className="cabTypeHead">
              <tr style={{ display: 'contents' }}>
                <th className="cabTypeCol textLeft">
                  <span>Routes</span>
                </th>
                <th className="cabTypeCol textLeft">
                  <span>
                    {localOperator
                      ? 'Earliest Bus'
                      : type === 'Operator'
                      ? `Popular Bus Types`
                      : `Popular Operators`}
                  </span>
                </th>
                {localOperator ? (
                  <th className="cabTypeCol textLeft">
                    <span> {'Last Bus'} </span>
                  </th>
                ) : (
                  ''
                )}
                <th className="cabTypeCol textLeft">
                  <span>Price</span>
                </th>
                <th className="cabTypeCol viewDtl">
                  <span> &nbsp;</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {data
                .filter((_, index) => showFullBuses || index < noOfListings)
                .map((item, index) => (
                  <tr
                    key={index}
                    className={index === 0 ? 'cabTypeRow noBdr' : 'cabTypeRow'}
                  >
                    <td className="cabTypeCol">
                      {item.seoUrl ? (
                        <p>
                          <a href={item.seoUrl} className={`cabTypeRoute`}>
                            {`${item.from_city_name} to  ${item.to_city_name} bus`}
                          </a>
                        </p>
                      ) : (
                        <p className={`cabTypeRoute`}>
                          {`${item.from_city_name} to  ${item.to_city_name} bus`}
                        </p>
                      )}
                      <p className="cabTimeDis">
                        {(() => {
                          if (type === 'Operator') {
                            return item.duration ? item.duration : null;
                          } else {
                            let durationAndDistanceString = '';
                            if (item.distance)
                              durationAndDistanceString = `${item.distance} kms `;
                            if (item.duration)
                              durationAndDistanceString = durationAndDistanceString.concat(
                                item.distance ? `| ` : ``,
                                `${item.duration}`
                              );
                            return durationAndDistanceString;
                          }
                        })()}
                      </p>
                    </td>
                    <td className="cabTypeCol">
                      <p style={{ width: '300px' }}>
                        {(() => {
                          //for operator template
                          if (localOperator) {
                            return item.firstDepartingBus;
                          } else if (type === 'Operator') {
                            return item.bus_types ? (
                              <span>{item.bus_types.join(', ')}</span>
                            ) : (
                              <span></span>
                            );
                          } else {
                            //for city template
                            return item.popular_operators
                              ? item.popular_operators.map((operator, idx) => {
                                  return operator.seoUrl ? (
                                    <>
                                      <a
                                        key={idx}
                                        className={`topOperatorFont`}
                                        href={operator.seoUrl}
                                      >
                                        {operator.operatorName}
                                      </a>
                                      {idx <
                                      item.popular_operators.length - 1 ? (
                                        <span>, </span>
                                      ) : (
                                        ''
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {' '}
                                      <span
                                        key={idx}
                                        className={`topOperatorFont`}
                                      >
                                        {operator.operatorName}
                                      </span>
                                      {idx <
                                      item.popular_operators.length - 1 ? (
                                        <span>, </span>
                                      ) : (
                                        ''
                                      )}
                                    </>
                                  );
                                })
                              : null;
                          }
                        })()}
                      </p>
                    </td>
                    {localOperator ? (
                      <td className="cabTypeCol">
                        <p>{item.lastDepartingBus}</p>
                      </td>
                    ) : (
                      ''
                    )}
                    <td className="cabTypeCol">
                      <p className="cabTypePrice">₹{item.min_price}</p>
                      <p className="cabTypeOnwards">onwards</p>
                    </td>
                    <td className="cabTypeCol">
                      <a
                        className="viewCabBtn"
                        onClick={() =>
                          busClick(
                            item.from_city_name,
                            item.to_city_name,
                            item.from_city_id,
                            item.to_city_id
                          )
                        }
                      >
                        {' '}
                        VIEW BUSES
                      </a>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div className="showMoreBuses">
          {data.length > noOfListings && (
            <button
              className="showMoreBusesButton"
              onClick={() => setShowFullBuses(!showFullBuses)}
            >
              {showFullBuses ? 'VIEW LESS' : 'VIEW MORE'}
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default TopBusesRoutes;
